"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_COBRAND_CARD_CONFIG_BY_PARTNER = exports.PartnerDashboardSubOrgTerminology = exports.CobrandCardProduct = exports.CobrandPartnerId = void 0;
/** @TranslateToPython @TranslateToEnum */
var CobrandPartnerId;
(function (CobrandPartnerId) {
    CobrandPartnerId["ForestRiver"] = "ForestRiver";
})(CobrandPartnerId || (exports.CobrandPartnerId = CobrandPartnerId = {}));
/** The Aven product a cobrand card fronts. Keys a partner's card art. */
var CobrandCardProduct;
(function (CobrandCardProduct) {
    CobrandCardProduct["homeEquity"] = "homeEquity";
    CobrandCardProduct["rewards"] = "rewards";
    CobrandCardProduct["deposit"] = "deposit";
})(CobrandCardProduct || (exports.CobrandCardProduct = CobrandCardProduct = {}));
var PartnerDashboardSubOrgTerminology;
(function (PartnerDashboardSubOrgTerminology) {
    PartnerDashboardSubOrgTerminology["Dealership"] = "dealership";
})(PartnerDashboardSubOrgTerminology || (exports.PartnerDashboardSubOrgTerminology = PartnerDashboardSubOrgTerminology = {}));
// Adding a new CobrandPartnerId without an entry here will fail tsc
exports.PUBLIC_COBRAND_CARD_CONFIG_BY_PARTNER = {
    [CobrandPartnerId.ForestRiver]: {
        displayName: 'Forest River',
        cardNames: {
            [CobrandCardProduct.homeEquity]: 'Homeline',
            [CobrandCardProduct.rewards]: 'Journey Rewards',
            [CobrandCardProduct.deposit]: 'Trailhead Deposit',
        },
        backgroundColor: '#1B5E20',
        accentColor: '#1D385B',
        partnerDashboardSubOrgTerminology: PartnerDashboardSubOrgTerminology.Dealership,
    },
};
